import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

class Button extends Component {
  static propTypes = {
    /* The text that will be displayed inside the button */
    text: PropTypes.string.isRequired,

    /* The icon that will be displayed inside the button */
    icon: PropTypes.string,

    /* Callback function that will be triggered when the button is clicked */
    onClick: PropTypes.func,

    disabled: PropTypes.bool,

    iconWidth: PropTypes.number,

    iconHeight: PropTypes.number,

    svgIcon: PropTypes.bool,

    svgComponent: PropTypes.any
  }

  handleClick = this.handleClick.bind(this)

  handleClick() {
    const { onClick } = this.props

    if (onClick) onClick()
  }

  render() {
    const { text, icon, iconWidth, iconHeight, disabled, svgIcon, svgComponent } = this.props
    return (
      <Fragment>
        <button

          disabled={disabled}
          className='btn-default'
          {...this.props}
          onClick={this.handleClick}
        >


          {!svgIcon && icon ? (
            <img
              src={icon}
              {...(iconWidth && { width: iconWidth })}
              {...(iconHeight && { height: iconHeight })}
            />
          ) : svgComponent}
          <span>{text}</span>
        </button>
      </Fragment>
    )
  }
}

export default Button
